module.exports = "h2 span {\n    color: #e74c3c\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/abastecimentos/tanques/tanque-movimentacao-area-form/tanque-movimentacao-area-form.component.css
 ** module id = 984
 ** module chunks = 0
 **/